import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './AuthPage.css';

function AuthPage({ role, title, icon, redirectPath }) {
  const { login, user } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === role) {
      navigate(redirectPath);
    }
  }, [user, navigate, role, redirectPath]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const loggedInUser = await login(email, password);

      if (loggedInUser.role === role) {
        navigate(redirectPath);
      } else {
        setError(`Only ${role === 'admin' ? 'admin' : role === 'teacher' ? 'teacher' : 'student'} users can access this area.`);
      }
    } catch (err) {
      setError('Login failed. Please check your information.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <section className="auth-hero">
        <div className="auth-hero-overlay">
          <div className="auth-hero-content animate-fade-in">
            <h1>Adam Academy {title}</h1>
            <p>Login to continue your leadership journey</p>
          </div>
        </div>
      </section>

      <section className="auth-form-section animate-slide-up">
        <div className="auth-container">
          <div className="auth-form-box">
            <div className="auth-form-header">
              <div className="auth-icon">{icon}</div>
              <h2>{title}</h2>
              <p>Login to access your account</p>
            </div>

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="example@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Enter your password"
                />
                <a href="/forgot-password" className="forgot-password">Forgot password?</a>
              </div>

              {error && <div className="error-message">{error}</div>}

              <button 
                type="submit" 
                className="auth-button"
                disabled={isLoading}
              >
                {isLoading ? 'Logging in...' : 'Login'}
              </button>
            </form>

            <div className="auth-footer">
              <p>Don't have an account? <a href="/register">Register now</a></p>
              <p><a href="/">Back to home page</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AuthPage;